/**
 * Whether the booking sidebar (סיכום הזמנה / itinerary stack) should mount.
 *
 * The results layout is used while the first search is still loading
 * (`searchPhase` is off because `loading` is true) even though `currentStep`
 * is still "search". That must not mount a $0 / "price unavailable" rail.
 *
 * The combined passengers + baggage screen is `extras` (wizard title
 * «פרטים ובחירת כבודה»). `passengers` is remapped onto extras but is
 * still hidden here if it ever becomes currentStep.
 */
export function shouldShowFlightBookingSidebar({
  currentStep,
  onFlightResultsListUrl,
  loading,
  selectedFlightOffer,
  hideEmptySelfComposeSidebar,
  /** When FLIGHT_ENGINE_UI_V2 Details surface is active — suppress legacy sidebar. */
  flightEngineUiV2DetailsSurface = false,
}) {
  // Greenfield Details owns StickyBookingSummary; never mount LiveSummary + DecisionCta.
  if (flightEngineUiV2DetailsSurface && currentStep === "flightDetails") {
    return false;
  }
  // PathSync often keeps /flights/results while currentStep is already
  // flightDetails. Still show the price rail on that details view (V1 only).
  if (onFlightResultsListUrl && currentStep !== "flightDetails") return false;
  if (currentStep === "results") return false;
  if (hideEmptySelfComposeSidebar) return false;
  if (currentStep === "search") return false;
  if (currentStep === "extras" || currentStep === "passengers") return false;
  if (Boolean(loading) && selectedFlightOffer == null) return false;
  return true;
}
